import AppConstants from './src/appConstants.js';
import themeConfig from "./themeConfig.js";

// if (themeConfig.client == AppConstants.PLATFORM_CLIENT.CMA) {
//     require('@/assets/scss/custom-cma.scss');
// }

// if (themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS) {
    require('@/assets/scss/custom-safras.scss');
// }

